<ew-mat-dialog-custom urlHelp="https://help.edvisor.io/edwallet/withdrawals">
  <ew-mat-stepper-custom
    [validations]="validations"
    [sendIn]="'penultimate'"
    [textForSendButton]="'shared:next'"
    (send)="send = $event">
    <!-- bank account v1-->
    <ew-mat-stepper-custom-step
      [classContainer]="'text-center grid gap-4 max-w-xl m-auto'"
      [title]="
        type === 'PAYOUT'
          ? 'createWithdrawMoney:providerTitle'
          : 'createWithdrawMoney:bankAccountTitle'
      "
      [subtitle]="
        type === 'PAYOUT'
          ? 'createWithdrawMoney:providerSubtitle'
          : 'createWithdrawMoney:bankAccountSubtitle'
      "
      *ngIf="showFirstStep">
      <ew-select-bank-account
        [width]="'100%'"
        [lookupForProviders]="type === 'PAYOUT'"
        [value]="bankAccount.value.currency"
        [limit]="PAGINATION_LIMIT"
        (valueChanged)="
          bankAccount.setValue($event);
          notification.patchValue({ email: $event.email })
        "></ew-select-bank-account>
    </ew-mat-stepper-custom-step>

    <!-- currencies -->
    <ew-mat-stepper-custom-step
      [classContainer]="'text-center grid gap-4 max-w-xl m-auto'"
      [title]="'createWithdrawMoney:currencyAccountTitle'"
      [subtitle]="'createWithdrawMoney:currencyAccountSubtitle'">
      <mat-progress-spinner
        class="m-auto my-5"
        [diameter]="24"
        [mode]="'indeterminate'"
        *ngIf="loadingCurrencies"></mat-progress-spinner>

      <div class="text-left grid xs:grid-cols-1 grid-cols-2 gap-4">
        <ew-currency-money
          [item]="item"
          [selected]="currency.value == item"
          [dollarConversion]="false"
          (click)="
            currency.setValue(item);
            rate.srcCurrency = item.currencyIso;
            getUpdatedValues();
            addAmountValidator()
          "
          *ngFor="let item of currencies"></ew-currency-money>
      </div>

      <treo-message
        class="mb-10 mx-4"
        [appearance]="unavailableWindowAlert.appearance"
        [showIcon]="unavailableWindowAlert.showIcon"
        [showButtonClose]="unavailableWindowAlert.showButtonClose"
        [type]="unavailableWindowAlert.type"
        *ngIf="isDuringUnavailableTimeRangeWindow === 'unavailable'">
        <div>
          <span>
            <!-- <b>{{ creditCardAlert.title! | translate }}:</b> -->
            {{ unavailableWindowAlert.content | translate }}
          </span>
        </div>
      </treo-message>
    </ew-mat-stepper-custom-step>

    <!-- set amount -->
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl m-auto">
        <div class="mb-5 text-5xl font-bold">
          {{ confirmationMessage | translate }}
        </div>
      </div>

      <!-- Currency -->
      <div class="pb-1 px-8">
        <h2 class="text-sm">
          {{
            'createWithdrawMoney:confirmationCurrencyAccountTitle' | translate
          }}
        </h2>
        <div class="border border-gray-300 rounded-md p-2">
          <ew-table-card-item
            [img]="
              'https://flagcdn.com/' +
              (currency.value.currencyIso | currencyCountry) +
              '.svg'
            "
            [title]="
              ('currencyName:' + currency.value.currencyIso | translate) +
              ' (' +
              currency.value.currencyIso +
              ')'
            "
            [subtitle]="
              'Currency Balance: ' + payoutUpdatedValues.balanceBefore
            "></ew-table-card-item>
        </div>
      </div>

      <!-- Amount -->
      <div class="pb-4 px-8">
        <label for="amount-sent">
          <h2 class="text-sm">
            {{ 'createWithdrawMoney:confirmationAmountSentTitle' | translate }}
          </h2>
        </label>
        <span class="font-bold text-5xl mr-2">{{
          getCurrencySymbol(currency.value.currencyIso)
        }}</span>
        <input
          ewPreventScroll
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          class="font-bold text-5xl mb-4"
          [formControl]="amount"
          placeholder="1.00"
          step=".01"
          id="amount-sent" />

        <div>
          <mat-error *ngIf="amount.errors?.min">
            <span class="text-sm">
              {{
                'createWithdrawMoney:confirmationMinimalAmountMessage'
                  | translate
              }}
            </span>
          </mat-error>
          <mat-error *ngIf="amount.errors?.max">
            <span class="text-sm">
              {{
                'createWithdrawMoney:confirmationNotEnoughBalanceMessage'
                  | translate
              }}
            </span>
          </mat-error>
          <mat-error *ngIf="amount.errors?.minAmount">
            <span class="text-sm"
              >{{ 'createWithdrawMoney:amountGreaterThan' | translate }}
              {{ amount.errors?.minAmount }}</span
            >
          </mat-error>
          <mat-error *ngIf="amount.errors?.maxAmount">
            <span class="text-sm"
              >{{ 'createWithdrawMoney:amountLowerThan' | translate }}
              {{ amount.errors?.maxAmount }}</span
            >
          </mat-error>
        </div>
        <p class="text-gray-500 text-sm" *ngIf="applicableFees.active">
          <span
            >{{ 'createWithdrawMoney:transactionFees' | translate }}:
            {{ applicableFee }}
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-25px]"
              [diameter]="20"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner
          ></span>
        </p>
        <p class="text-gray-500 text-sm" *ngIf="applicableFees.active">
          <span
            >{{ 'createWithdrawMoney:transactionTotalWithFees' | translate }}:
            {{ applicableTotalAmount }}
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-25px]"
              [diameter]="20"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner
          ></span>
        </p>
        <p
          class="text-sm {{
            actualBalance < 0 ? 'text-red-600' : 'text-gray-500'
          }}">
          <span class="relative">
            {{
              'createWithdrawMoney:confirmationAmountSentBalance' | translate
            }}:
            {{ payoutUpdatedValues.balanceAfter }}
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-25px]"
              [diameter]="20"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner>
          </span>
        </p>
        <p *ngIf="actualBalance < 0" class="text-sm text-red-600">
          <span class="relative">{{
            'createWithdrawMoney:confirmationNotEnoughBalanceMessage'
              | translate
          }}</span>
        </p>
      </div>

      <!-- Beneficiary Account -->
      <div class="pb-2 px-8">
        <h2 class="text-sm">
          {{
            'createWithdrawMoney:confirmationBeneficiaryAccountTitle'
              | translate
          }}
        </h2>
        <div class="border border-gray-300 rounded-md p-2">
          <ew-table-card-item
            *ngIf="bankAccount.value.currency"
            [img]="
              'https://flagcdn.com/' +
              (bankAccount.value.currency | currencyCountry) +
              '.svg'
            "
            [title]="bankAccount.value.payee.name"
            [subtitle]="
              (bankAccount.value.accountNumber | maskAccountNumber) +
              ' | ' +
              ('country:' + bankAccount.value.country.toUpperCase()
                | translate) +
              ' | ' +
              ('currencyName:' + bankAccount.value.currency | translate)
            "></ew-table-card-item>
        </div>
      </div>

      <!-- Beneficiary Amount -->
      <div class="px-8 pb-4">
        <h2 class="text-sm">
          {{
            'createWithdrawMoney:confirmationBeneficiaryAmountTitle' | translate
          }}
        </h2>
        <p class="font-bold text-xl">
          <span class="relative">
            {{ payoutUpdatedValues.beneficiaryAmount }}
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-30px]"
              [diameter]="20"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner>
          </span>
        </p>
        <p class="text-gray-500 text-sm">
          <span class="relative">
            FX RATES:
            {{ payoutUpdatedValues.fxRateBaseCurrency }} =
            {{ payoutUpdatedValues.fxRateDestCurrency }}
            ({{
              'createWithdrawMoney:confirmationBeneficiaryAmountRates'
                | translate
            }})
            <mat-progress-spinner
              class="absolute top-[50%] translate-y-[-50%] right-[-30px]"
              [diameter]="24"
              [mode]="'indeterminate'"
              *ngIf="loadingRate"></mat-progress-spinner>
          </span>
        </p>
      </div>

      <!-- Type for US and CA only -->
      <div
        class="px-8 pb-4"
        *ngIf="
          ew1889.variable &&
          (bankAccount.value.country === 'ca' ||
            bankAccount.value.country === 'us')
        ">
        <mat-label class="font-semibold mb-2">
          <h2 class="text-sm">
            {{ 'transactions:method' | translate }}
          </h2>
        </mat-label>
        <mat-select
          class="block w-full p-2 border rounded-md"
          name="payment-method"
          [formControl]="paymentMethod">
          <mat-option [value]="20">ACH Transfer</mat-option>
          <mat-option [value]="2">Domestic Wire Transfer</mat-option>
        </mat-select>
      </div>

      <!-- Reference -->
      <div class="px-8 pb-4">
        <mat-label class="font-semibold mb-2">
          <h2 class="text-sm">
            {{ 'transactions:reference' | translate }}
          </h2>
        </mat-label>
        <input
          class="block w-full p-2 border rounded-md {{
            reference.errors && reference.value !== ''
              ? 'border-red-500'
              : 'border-gray-300'
          }}"
          matInput
          required
          [formControl]="reference"
          name="reference" />

        <mat-error *ngIf="reference.errors?.minlength">
          <span class="text-sm">{{
            reference.errors?.minlength | errorMinValue
          }}</span>
        </mat-error>
        <mat-error *ngIf="reference.errors?.maxlength">
          <span class="text-sm">{{
            reference.errors?.maxlength | errorMaxValue
          }}</span>
        </mat-error>
        <mat-error *ngIf="reference.errors?.required && reference.touched">
          <span class="text-sm">{{ 'shared:isRequired' | translate }}</span>
        </mat-error>
        <mat-error *ngIf="reference.errors?.pattern">
          <span class="text-sm">{{
            'shared:noSpecialCharacters' | translate
          }}</span>
        </mat-error>
      </div>

      <!-- Warning/Info Banners -->
      <div>
        <div class="max-w-[704px] m-auto mb-4 text-sm text-yellow-500">
          <h2 class="font-bold">
            {{ 'createWithdrawMoney:confirmationWarningTitle' | translate }}
          </h2>
          <p>
            {{ 'createWithdrawMoney:confirmationWarningContent' | translate }}
          </p>
        </div>
        <div class="max-w-[704px] m-auto text-sm text-blue-500">
          <p>
            {{ 'createWithdrawMoney:confirmationInfoContent' | translate }}
          </p>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- loader send -->
    <ew-mat-stepper-custom-step
      [classContainer]="'text-center grid gap-4 max-w-3xl m-auto mb-5'"
      [title]="!validatedCode ? 'createWithdrawMoney:validatedCodeTitle' : ''"
      [subtitle]="
        !validatedCode ? 'createWithdrawMoney:validatedCodeSubtitle' : ''
      "
      [message]="message">
      <img
        class="w-{{
          validatedCode ? '3/5' : '44'
        }} m-auto transition duration-1000 ease-in-out"
        [class.fly]="validatedCode"
        [class.scale-150]="validatedCode"
        *ngIf="validatedCode"
        src="assets/fly.svg"
        alt="" />
      <div *ngIf="!validatedCode" class="transition duration-1000 ease-in-out">
        <ew-validation-code
          class="max-w-xl m-auto"
          (validated)="createWithdrawMoney($event)"
          *ngIf="send"
          [type]="type"
          [hasSubmitted]="lockSendPayoutSubmit"></ew-validation-code>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
